import { Share2 } from "lucide-react";
import { useUiStore } from "@/lib/stores/uiStore";

// Solo móvil: en escritorio las acciones viven en la cabecera de cada página (rediseño 2026-07-02).
export const Topbar = () => {
  const openCapture = useUiStore((s) => s.openCapture);

  return (
    <header className="md:hidden h-14 border-b flex items-center gap-3 px-4 shrink-0 bg-background" data-testid="topbar">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-md bg-primary text-primary-foreground grid place-items-center font-serif text-base">
          A
        </div>
        <span className="font-serif text-lg tracking-tight">Aviando</span>
      </div>

      <button
        type="button"
        onClick={openCapture}
        aria-label="Capturar contenido"
        data-testid="topbar-share-button"
        className="ml-auto w-9 h-9 rounded-full bg-primary text-primary-foreground grid place-items-center"
      >
        <Share2 className="h-4 w-4" strokeWidth={1.75} />
      </button>
    </header>
  );
};
